<span
  >{{ person.firstName }} {{ person.middleName }} {{ person.lastName }}</span
>

@if (person.email) {
  <span> - {{ person.email }}</span>
}

@if (person.city && person.state) {
  <span> - {{ person.city }}, {{ person.state }}</span>
} @else if (person.city) {
  <span> - {{ person.city }}</span>
} @else if (person.state) {
  <span> - {{ person.state }}</span>
}

@if (person.credentials?.length === 1) {
  <span>
    -
    <ng-container
      *ngTemplateOutlet="
        credential;
        context: { $implicit: person.credentials[0] }
      "
    />
  </span>
} @else if (person.credentials?.length > 1) {
  <ul class="result-credentials">
    @for (c of person.credentials; track c.credentialName) {
      <li>
        <ng-container
          *ngTemplateOutlet="credential; context: { $implicit: c }"
        />
      </li>
    }
  </ul>
}

<ng-template #credential let-c>
  <span>{{ c.credentialName }}</span>
  @if (c.credentialNumber) {
    <span> #{{ c.credentialNumber }}</span>
  }
  @if (c.credentialStatus) {
    <span> - {{ c.credentialStatus }}</span>
  }
</ng-template>
